import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SnBadgeDirective } from './directives/badge.directive';

@NgModule({
  imports: [
    // Angular
    CommonModule,
  ],
  exports: [
    // Directives
    SnBadgeDirective,
  ],
  declarations: [
    // Directives
    SnBadgeDirective,
  ],
})
export class SnBadgeModule {}
